module.exports = "data:image/png;base64,UklGRiYBAABXRUJQVlA4WAoAAAAQAAAADgAACgAAQUxQSHAAAAABr6CgjSQ1ePDMIID/IyJAinzGZ1SdK6OSQkp3oaCNJGWfmf/8i32UENF/hW3bNtk7ac8AbJ40s8WOfrSSSht+YztqcNqFOqwSQG5BLwwtq84xi9vAlakoMkp6x0SSSF2FpMju4cjubZJ9vBcw198AVlA4IJAAAADQAgCdASoPAAsAAgA0JQBdj+AQR+6rOEMBdVYcvDcAAP7wQh+O/yr38m3k1Phj/Wtxy+PDKfo+a45t4nX6BV7zcTwxXzkfNrmf6f4zHqfyix8ZyGt5c69GcEKI0+ijvH3s+lqhndIui8CBEs0xx+cI+WwyhAAJt/8hH55PR3a3HXzHa3JSiRG1dZd7uMRgAAA="


//////////////////
// WEBPACK FOOTER
// ./src/Assets/nodes/Pin_disconnected_VarA.png
// module id = 35
// module chunks = 0